/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable array-callback-return */
/* eslint-disable dot-notation */
/* eslint-disable react/button-has-type */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-key */
/* eslint-disable react-hooks/exhaustive-deps */
import * as Yup from 'yup';
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ImageUploading from 'react-images-uploading';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Grid,
  Stack,
  Container,
  Box,
  Button,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  Checkbox,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from '../../../utils/axios';
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { FormProvider, RHFCheckbox, RHFRadioGroup, RHFSelect, RHFTextField } from '../../../components/hook-form';

export default function AddListing() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [checked, setchecked] = useState(false);
  // const token = localStorage.getItem('accessToken');

  // const [tableData, setTableData] = useState([]);
  // const [Facility, setFacility] = useState([]);

  // async function AllUsers() {
  //   const data = await axios.get('amenity');
  //   setTableData(data?.data?.data);
  // }
  // async function AllFacility() {
  //   const data = await axios.get('facility');
  //   setFacility(data?.data?.data);
  // }

  useEffect(() => {
    // AllUsers();
    // AllFacility();
  }, []);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedCheckboxes((prevSelected) =>
      checked ? [...prevSelected, value] : prevSelected.filter((item) => item !== value)
    );
  };
  const [selectedCheckboxesOne, setSelectedCheckboxesOne] = useState([]);
  const handleCheckboxChangeOne = (event) => {
    const { value, checked } = event.target;
    setSelectedCheckboxesOne((prevSelected) =>
      checked ? [...prevSelected, value] : prevSelected.filter((item) => item !== value)
    );
  };

  const NewProviderSchema = Yup.object().shape({
    name: Yup.string(),
    address: Yup.string(),
    description: Yup.string(),
    agent_commission: Yup.string(),
    bathroom: Yup.string(),
    bedroom: Yup.string(),
    commercial: Yup.string(),
    land: Yup.string(),
    listing: Yup.string(),
    lot_size: Yup.string(),
    neighborhoods: Yup.string(),
    offmarket: Yup.string(),
    price: Yup.string(),
    rentals: Yup.string(),
    request_email: Yup.string(),
    schedule_email: Yup.string(),
    square_feet_size: Yup.string(),
  });

  const defaultValues = useMemo(
    () => ({
      name: '',
      address: '',
      description: '',
      agent_commission: '',
      bathroom: '',
      listing: '',
      bedroom: '',
      commercial: '',
      land: '',
      // listing:'',
      lot_size: '',
      neighborhoods: '',
      offmarket: '',
      price: '',
      rentals: '',
      request_email: '',
      schedule_email: '',
      square_feet_size: '',
    }),
    //  eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Multiple Input Two Code Start

  const [extraServicePrices, setExtraServicePrices] = useState([{ name: '', price: '', type: '' }]);

  const handleInputChangeOne = (index, field, value) => {
    const newExtraServicePrices = [...extraServicePrices];
    newExtraServicePrices[index][field] = value;
    setExtraServicePrices(newExtraServicePrices);
  };

  const handlePlusClickOne = () => {
    setExtraServicePrices([...extraServicePrices, { name: '', price: '', type: '' }]);
  };

  const handleMinusClickOne = (index) => {
    if (extraServicePrices.length > 1) {
      const newExtraServicePrices = [...extraServicePrices];
      newExtraServicePrices.splice(index, 1);
      setExtraServicePrices(newExtraServicePrices);
    }
  };

  // Multiple Input Two Code End
  // Multiple Input Two Code Start

  const [bedroomsExtra, setBedroomsExtra] = useState([{ name: '', no_of_guest: '', no_of_bed: '', bed_type: '' }]);

  const handleInputChangeTwo = (index, field, value) => {
    const newExtraServicePrices = [...bedroomsExtra];
    newExtraServicePrices[index][field] = value;
    setBedroomsExtra(newExtraServicePrices);
  };

  const handlePlusClickTwo = () => {
    setBedroomsExtra([...bedroomsExtra, { name: '', no_of_guest: '', no_of_bed: '', bed_type: '' }]);
  };

  const handleMinusClickTwo = (index) => {
    if (extraServicePrices.length > 1) {
      const newExtraServicePrices = [...bedroomsExtra];
      newExtraServicePrices.splice(index, 1);
      setBedroomsExtra(newExtraServicePrices);
    }
  };

  // Multiple Input Two Code End

  const [images, setImages] = useState([]);
  const maxNumber = 69;
  const onChange = (imageList) => {
    setImages(imageList);
  };

  const methods = useForm({
    resolver: yupResolver(NewProviderSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    // console.log(data?.rentals, 'data?.rentals');
    try {
      const Data = new FormData();
      Data.append('name', data.name);
      Data.append('address', data.address);
      Data.append('description', data.description);
      Data.append('agent_commission', data.agent_commission);
      Data.append('bathroom', Number(data.bathroom));
      Data.append('bedroom', Number(data.bedroom));
      Data.append('commercial', data.commercial? 1 : 0);
      Data.append('land', data.land? 1 : 0);
      Data.append('listing', data.listing);
      Data.append('lot_size', data.lot_size);
      Data.append('neighborhoods', data.neighborhoods);
      Data.append('offmarket', data.offmarket? 1 : 0);
      Data.append('price', data.price);
      Data.append('rentals', data.rentals ? 1 : 0);
      Data.append('request_email', data.request_email);
      Data.append('schedule_email', data.schedule_email);
      Data.append('square_feet_size', data.square_feet_size);

      images?.map((item, index) => {
        Data.append(`images[${index}]`, item?.file);
      });

      await axios.post(`admin/listing`, Data).then((response) => {
        console.log(response, 'add');
        if (response?.data?.status === true) {
          enqueueSnackbar('Listing Add Successfully');
          reset();
          navigate('/dashboard/home');
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  };

  return (
    <Container maxWidth="xl">
      <HeaderBreadcrumbs heading="Add Listing" links={[{ name: '', href: '' }]} />

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} mt={5}>
            <Card sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' },
                }}
              >
                <Grid item xs={12}>
                  <RHFTextField name="name" label="Name" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="address" label="Address" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="description" label="Description" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="agent_commission" label="Agent Commission" type="number" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="bathroom" label="Bathroom" type="number" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="bedroom" label="Bedroom" type="number" />
                </Grid>
                {/* <Grid item xs={12}>
                  <RHFTextField name="commercial" label="Commercial" type="number" />
                </Grid> */}
                {/* <Grid item xs={12}>
                  <RHFTextField name="land" label="Land" type="number" />
                </Grid> */}

                <Grid item xs={12}>
                  <RHFSelect name="listing" label="Select City" placeholder="Select Status">
                    <option value="Albir">Albir</option>
                    <option value="Alfas del pi">Alfas del pi</option>
                    <option value="Altea">Altea</option>
                    <option value="Benidorm">Benidorm</option>
                    <option value="La Nucia">La Nucia</option>
                  </RHFSelect>
                </Grid>
                {/* <Grid item xs={12}> */}

                {/* <RHFTextField name="listing" label="Listing" /> */}
                {/* </Grid> */}
                <Grid item xs={12}>
                  <RHFTextField name="lot_size" label="Lot Size" type="number" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="neighborhoods" label="Neighborhoods" />
                </Grid>
                {/* <Grid item xs={12}>
                  <RHFTextField name="offmarket" label="offmarket" type="number" />
                </Grid> */}
                <Grid item xs={12}>
                  <RHFTextField name="price" label="Price" type="number" />
                </Grid>
                {/* <Grid item xs={12}>
                  <RHFTextField name="rentals" label="Rentals"  type="number"/>
                </Grid> */}
                <Grid item xs={12}>
                  <RHFTextField name="request_email" label="Request Email" type="email" />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField name="schedule_email" label="Schedule Email" type="email" />
                </Grid>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  marginTop: 4,
                  alignItems: 'center',
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(5, 1fr)' },
                }}
              >
                <Grid item xs={12}>
                  <RHFTextField name="square_feet_size" label="Square Feet Size" type="number" />
                </Grid>
                <Grid item xs={12}>
              
                  <RHFCheckbox
                  label={"Rentals"}
                    name="rentals"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  {/* <RHFRadioGroup name="rentals" options={['1']} getOptionLabel={['Rentals']} /> */}
                </Grid>
              
                <Grid item xs={12}>
                <RHFCheckbox
                  label={"commercial"}
                    name="commercial"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </Grid>
                <Grid item xs={12}>
                <RHFCheckbox
                  label={"land"}
                    name="land"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </Grid>
                <Grid item xs={12}>
                <RHFCheckbox
                  label={"offmarket"}
                    name="offmarket"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </Grid>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  marginTop: 4,
                  alignItems: 'center',
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                }}
              >
                <ImageUploading multiple value={images} onChange={onChange} maxNumber={maxNumber} dataURLKey="data_url">
                  {({ imageList, onImageUpload, isDragging, dragProps }) => (
                    <Box
                      sx={{
                        position: 'relative',
                        '& button': {
                          border: 'none',
                          background: isDragging ? '#F5003F' : 'none',
                          backgroundSize: 'cover',
                          backgroundColor: '#F5003F',
                          width: '100%',
                          height: 120,
                          color: isDragging ? 'white' : 'white',
                        },
                      }}
                    >
                      <Button onClick={onImageUpload} {...dragProps} fullWidth>
                        Click or Drop here <CloudUploadIcon className="ms-2" />
                      </Button>
                      <div className="d-flex flex-wrap justify-content-around align-items-center">
                        {imageList?.map((image, index) => (
                          <div key={index} className="image-item mt-3">
                            <img
                              src={image['data_url']}
                              alt=""
                              width="100"
                              height="100"
                              style={{ objectFit: 'cover', borderRadius: '50%', border: '1px solid #F5003F' }}
                            />
                          </div>
                        ))}
                      </div>
                    </Box>
                  )}
                </ImageUploading>
              </Box>

              <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                  Add Listing
                </LoadingButton>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </FormProvider>
    </Container>
  );
}
